module.exports = __webpack_public_path__ + "img/icoon_bezinning_small.f8a0e8ba.svg";